import { BodyText } from '@/components/BodyText';
import { TextButton } from '@/components/TextButton';
import { WhiteButton } from '@/components/WhiteButton';
import { Delete, Save } from '@mui/icons-material';
import { Box } from '@mui/material';

interface MetadataActionsProperties {
  onSave: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
  isSaveDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isLoading?: boolean;
  saveLabel?: string;
  deleteLabel?: string;
  cancelLabel?: string;
}

export const MetadataActions = ({
  onSave,
  onCancel,
  onDelete,
  isSaveDisabled = false,
  isDeleteDisabled = false,
  isLoading = false,
  saveLabel = 'Save',
  deleteLabel = 'Delete',
  cancelLabel = 'Cancel',
}: MetadataActionsProperties) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-start' }}>
      <WhiteButton size='small' onClick={onSave} disabled={isSaveDisabled || isLoading}>
        <Save sx={{ fontSize: '16px' }} />
        <BodyText>{saveLabel}</BodyText>
      </WhiteButton>

      {onDelete && (
        <WhiteButton size='small' onClick={onDelete} disabled={isDeleteDisabled || isLoading}>
          <Delete sx={{ fontSize: '16px' }} />
          <BodyText>{deleteLabel}</BodyText>
        </WhiteButton>
      )}

      {onCancel && (
        <TextButton onClick={onCancel} variant='text' disableTouchRipple>
          <BodyText>{cancelLabel}</BodyText>
        </TextButton>
      )}
    </Box>
  );
};
